import { render, staticRenderFns } from "./Balance.html?vue&type=template&id=1ec4d10b&scoped=true&external"
import script from "./Balance.vue?vue&type=script&lang=js"
export * from "./Balance.vue?vue&type=script&lang=js"
import style0 from "./Balance.scss?vue&type=style&index=0&id=1ec4d10b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ec4d10b",
  null
  
)

export default component.exports